export default "__VITE_ASSET__CMU5Tvfj__"